import React from 'react';
import { Link } from 'react-router-dom';

const SiteNavbar = () => {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-lg border-b border-gray-800">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-4 no-underline">
            <img src="/rciti_top_logo.jpg" alt="UNSW rCITI" className="h-10 w-auto" />
            <div className="h-8 w-px bg-gray-700"></div>
            <span className="text-white font-semibold">FreightLabX</span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <a href="/#projects" className="text-gray-400 hover:text-unsw-yellow transition-colors text-sm font-medium no-underline">
              Projects
            </a>

            <a href="/#team" className="text-gray-400 hover:text-unsw-yellow transition-colors text-sm font-medium no-underline">
              Team
            </a>

            <a href="/#about" className="text-gray-400 hover:text-unsw-yellow transition-colors text-sm font-medium no-underline">
              About
            </a>
{/* 
            <Link to="/app" className="text-gray-400 hover:text-unsw-yellow transition-colors text-sm font-medium no-underline">
              E-RailOpt
            </Link>

            <Link to="/app/forklift-planner" className="text-gray-400 hover:text-unsw-yellow transition-colors text-sm font-medium no-underline">
              Forklift Planner
            </Link> */}

            {/* <Link to="/app" className="bg-unsw-yellow text-black font-semibold px-4 py-2 rounded-lg hover:bg-yellow-400 transition-all text-sm no-underline">
              Launch E-Rail Opt
            </Link> */}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default SiteNavbar;